import React, { useEffect, useState } from 'react';
import '.././App.css';
import { CallClient } from "@azure/communication-calling";
import { AzureCommunicationTokenCredential } from '@azure/communication-common';

function AzureCTD() {
  const [callState, setCallState] = useState('');
  const [callItem, setCallItem] = useState(undefined);
  const [callAgentObject, setCallAgentObject] = useState(null);

  const handleMessage = async (event) => {  
    // if (event.origin !== 'http://your-parent-origin.com') return;
    if (event.data.type) {
      console.log("RA: "+ event.data.type);
      console.log(new Date());  
      if (event.data.type === 'startCall') {
        const callClient = new CallClient();
        const tokenCredential = new AzureCommunicationTokenCredential(event.data.data.token);
        const callAgent = await callClient.createCallAgent(tokenCredential);
        const call = await callAgent.startCall(
          [{phoneNumber: event.data.data.phoneToCall}], { alternateCallerId: {phoneNumber: event.data.data.callerId}, recordingOptions: { isEnabled: true }
        });
        
        setCallItem(call);
        call.on('stateChanged', async () => {
          setCallState(call.state);
          window.parent.postMessage({data: {type: "state", state: call.state}}, "*");

          if (call.state === 'Disconnected') {
            window.parent.postMessage({data: {type: "state", state: "completed"}}, "*");

            console.log("Disposing call agent");
            callAgent.dispose();
          } else if (call.state ==='Connected') {
            window.parent.postMessage({data: {type: "state", state: "in-progress"}}, "*");
            call.info.getServerCallId().then(result => {
              const serverCallId = result;
              window.parent.postMessage({data: {type: "callId", serverCallId: serverCallId}}, "*");
            });
          }
        });        
      } else if (event.data.type === 'mute') {
        callItem.mute();
      } else if (event.data.type === 'unmute') {
        callItem.unmute()
      } else if (event.data.type === 'endcall') {
        callItem.hangUp({
          forEveryone: true
        });
      }
      //window.addEventListener('message', handleMessage, false);
    }
  };

   useEffect(() => {     
      window.addEventListener('message', handleMessage, false); 

      return () => {
        window.removeEventListener('message', handleMessage);
      };
   });

  return (
    <div className="App">
      <div>
        <p>Current State: {callState}</p>
      </div>
    </div>
  );
}

export default AzureCTD;